const React = require('react');
const ReactDOM = require('react-dom');
let Components = require('./components');

module.exports = (additionalComponents = {}) => {

  Components = Object.assign({}, Components, additionalComponents);

  Array.from(document.querySelectorAll('[data-vogue-component]')).forEach((el) => {

    const componentType = Components[el.attributes.getNamedItem('data-vogue-component').value];

    const props = Array.prototype.reduce.call(el.attributes, (map, attribute) => {
      const prefix = 'data-vogue-prop-';

      if (attribute.name.startsWith(prefix) && attribute.name !== 'data-vogue-component') {

        let matchedProp = attribute.name.substring(prefix.length);

        // html attributes are case insensitive
        Object.keys(componentType.propTypes).forEach((prop) => {
          if (matchedProp.toLowerCase() === prop.toLowerCase()) {
            matchedProp = prop; // take casing from the component, not the dom
          }
        });

        let value = attribute.value;
        if (componentType.propTypes[matchedProp]({ value }, 'value')) {
          // Since the value doesn't validate, we will try parsing the value as JSON.
          try {
            value = JSON.parse(value);
          } catch (e) {
            console.error(e); // eslint-disable-line no-console
          }
        }

        map[matchedProp] = value;
      }

      return map;
    }, {});

    const reactEl = React.createElement(componentType, props, el.textContent);

    ReactDOM.render(reactEl, el);
  });
};
